export default "__VITE_PUBLIC_ASSET__70973df9__"